import Vue from 'vue'
import createMD5 from 'js-md5'

import {getUploadSTSToken} from '@/tools/get-ststoken'

import {downloadFileApi as getFileArrayBuffer, ossFindAttachments} from '@/service/util'

import jstz from 'jstz'
import router from '../router'

import * as math from 'mathjs'

import VueCookies from '@/plugins/vueCookies.js'
import {getBrightHexColor} from '@/tools/color'
import {getBaseUrl} from '@/tools/async-tool'
import { lockrSet, lockrGet, lockrRm } from '@/tools/lockr'

import JsSHA1 from 'jssha/sha1'
import moment from 'moment'
// import store from '@/store'

function resolveElementUI () {
  if (typeof globalThis !== 'undefined' && globalThis.ElementUI) {
    return globalThis.ElementUI
  }
  if (typeof window !== 'undefined' && window.ElementUI) {
    return window.ElementUI
  }
  return null
}

function resolveLoadingService () {
  const ui = resolveElementUI()
  if (ui && ui.Loading && typeof ui.Loading.service === 'function') {
    return ui.Loading.service
  }
  if (Vue && Vue.prototype && Vue.prototype.$loading) {
    return Vue.prototype.$loading
  }
  return function () {
    return { close: function () {} }
  }
}

const Loading = {
  service: function (...args) {
    const service = resolveLoadingService()
    return service.apply(null, args)
  }
}

function resolveMessage () {
  const ui = resolveElementUI()
  return (ui && ui.Message) || (Vue && Vue.prototype && Vue.prototype.$message) || null
}

const Message = function (...args) {
  const message = resolveMessage()
  if (typeof message === 'function') {
    return message.apply(null, args)
  }
}
Message.error = function (...args) {
  const message = resolveMessage()
  if (message && typeof message.error === 'function') {
    return message.error.apply(message, args)
  }
  if (typeof message === 'function') {
    return message.apply(null, args)
  }
}

let aliOSSModulePromise = null

function resolveModule (mod) {
  return mod && mod.default ? mod.default : mod
}

function getAliOSSModule () {
  if (aliOSSModulePromise) {
    return aliOSSModulePromise
  }
  if (typeof require !== 'undefined') {
    try {
      const mod = require('ali-oss')
      aliOSSModulePromise = Promise.resolve(resolveModule(mod))
      return aliOSSModulePromise
    } catch (e) {
      // fall through to dynamic import
    }
  }
  aliOSSModulePromise = import('ali-oss').then(resolveModule)
  return aliOSSModulePromise
}

// 国外机构
const overseasOrgid = [34263, 35041, 46521]

// import { JUDGEFROMMANBAN } from '@/tools/content_setting'

// 暂时不要使用（仍存在问题） 因为在同一个页面同一个Loading实例，有时loading加载，有时不loading加载
export function lazyLoadView (asyncView, options) {
  const deafultOptions = {
    background: '#fff',
    spinner: 'manban-page-loading',
    text: '加载中'
  }

  const loadingInstance = Loading.service(Object.assign({
    ...(options)
  }, deafultOptions))

  const errorInstaceFunc = () => Message.error('功能模块加载失败，请检查网络或者刷新重试')

  // console.log(errorInstaceFunc(), 'errorInstaceFunc')
  const asyncHandler = () => ({
    component: asyncView,

    // https://blog.csdn.net/Alecor/article/details/83056952

    // loading: loadingInstance,
    // error: errorInstaceFunc,
    // Delay before showing the loading component.
      // Default: 200 (milliseconds).
    delay: 200,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 60000
  })

  return Promise.resolve({
    functional: true,
    render: (h, { data, children }) => {
      // Transparently pass any props or children
      // to the view component.
      return h(asyncHandler, data, children)
    }
  }).then((res) => {
    loadingInstance.close()

    lockrRm('lazyImportFail')

    return res
  }, (err) => {
    loadingInstance.close()

    const lazyImportFailNumber = parseInt(lockrGet('lazyImportFail'))

    if (lazyImportFailNumber) {
      if (lazyImportFailNumber < 3) {
        window.location.href = window.location.href

        lockrSet('lazyImportFail', lazyImportFailNumber + 1)
      } else {
        errorInstaceFunc()
      }
    } else {
      lockrSet('lazyImportFail', 1)
    }

    // window.Location.reload(true);

    return err
  })
}

function dateFormate ({ timestamp, timestr, tspmode = 0, tsrmode = 0, card_type, hasSpace = false}) {
  let date = null
  // console.log(arguments);

  function formatNumber (num) {
    return num.toString()[1] ? num + '' : '0' + num
  }

  timestamp && (date = new Date(timestamp * 1000))
  if (timestamp && (tspmode == 0)) { // 2019年10月11日 10:00:39
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    let hour = date.getHours()

    let min = date.getMinutes()

    let sec = date.getSeconds()

    return year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日' + (hasSpace ? ' ' : '') + formatNumber(hour) + ':' + formatNumber(min) + ':' + formatNumber(sec)
  } else if (timestamp && (tspmode == 1)) { // 2019年12月11日
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    return year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日'
  } else if (timestamp && (tspmode == 2)) {  // 2019年12月11日 09:00
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    let hour = date.getHours()

    let min = date.getMinutes()

    return year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日' + (hasSpace ? ' ' : '') + formatNumber(hour) + ':' + formatNumber(min)
  } else if (timestamp && (tspmode == 3)) { // （时长1小时50分钟20秒）
    let second = timestamp % 60

    let minute = Math.floor(timestamp / 60) ? Math.floor(timestamp / 60) % 60 : 0

    let hour = Math.floor(timestamp / 3600) ? Math.floor(timestamp / 3600) % 60 : 0

    let day = Math.floor(timestamp / (3600 * 24)) ? Math.floor(timestamp / (3600 * 24)) % 24 : 0

    return `（时长${day ? day + '天' : ''}${hour ? hour + '小时' : ''}${minute ? minute + '分钟' : ''}${second}秒）`
  } else if (timestamp && (tspmode == 4)) {  // 2020-02-12
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    return year + '-' + formatNumber(month) + '-' + formatNumber(day)
  } else if (timestamp && (tspmode == 5)) {  // 有效期至2019年10月29日  或者 到期日2019年10月31日
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    let card_expires = ''

    switch (card_type) {
      case 'class_hour':
        card_expires = `有效期至${hasSpace ? ' ' : ''}${year}年${formatNumber(month)}月${formatNumber(day)}日`
        break
      case 'duration':
        card_expires = `到期日${year}年${formatNumber(month)}月${formatNumber(day)}日`
        break
    }

    return card_expires
  } else if (timestamp && (tspmode == 6)) { // 2020/02/12
    let year = date.getFullYear()

    let month = date.getMonth() + 1

    let day = date.getDate()

    return year + '/' + formatNumber(month) + '/' + formatNumber(day)
  } else if (timestamp && (tspmode == 7)) {  // 06:30
    let hour = date.getHours()

    let min = date.getMinutes()

    // let sec = date.getSeconds();

    return formatNumber(hour) + ':' + formatNumber(min)  // + ':' + formatNumber(sec)
  }

  timestr && (date = timestr.split('-'))
  if (timestr && (tsrmode == 0)) {  // 有效期至2019年10月29日  或者 到期日2019年10月31日
    let year = date[0] - 0

    let month = date[1] - 0

    let day = date[2] - 0

    let card_expires = ''

    switch (card_type) {
      case 'class_hour':
        card_expires = `有效期至${hasSpace ? ' ' : ''}${year}年${formatNumber(month)}月${formatNumber(day)}日`
        break
      case 'duration':
        card_expires = `到期日${year}年${formatNumber(month)}月${formatNumber(day)}日`
        break
    }

    return card_expires
  } else if (timestr && (tsrmode == 1)) {  // 2019年02月10日
    let year = date[0] - 0

    let month = date[1] - 0

    let day = date[2] - 0

    return `${year}年${formatNumber(month)}月${formatNumber(day)}日`
  } else if (timestr && (tsrmode == 2)) {  // 2月2日(周四)
    let year = date[0] - 0

    let month = date[1] - 0

    let day = date[2] - 0

    let dayOfWeek = (new Date(year, month - 1, day)).getDay()

    let day_week_str = getWeekStr(dayOfWeek)

    return `${month}月${day}日(${day_week_str})`
  } else if (timestr && (tsrmode == 3)) { //  获取时间戳
    let year = date[0] - 0

    let month = date[1] - 0

    let day = date[2] - 0

    return (new Date(year, month - 1, day)).valueOf()
  }
}

function getWeekStr (dayOfWeek) {
  if (typeof dayOfWeek !== 'number' || !(dayOfWeek >= 0 && dayOfWeek <= 6)) {
    return ''
  }

  switch (dayOfWeek) {
    case 0:
      return '周日'
      break
    case 1:
      return '周一'
      break
    case 2:
      return '周二'
      break
    case 3:
      return '周三'
      break
    case 4:
      return '周四'
      break
    case 5:
      return '周五'
      break
    case 6:
      return '周六'
      break
  }

  return ''
}

function getAddOrSubDayDate ({timestr, timestamp, changeStep = 0, mode = 0, outNewTsp = false, addZero = false }) {
  function formateNumber (str) {
    return str.toString()[1] ? str : '0' + str
  }

  // 注意：日期加减必须按"日历日"进行，不能用毫秒数(changeStep * 86400000)硬加。
  // 否则在有夏令时(DST)的时区(如纽约)跨越夏令时切换时，24h≠1个日历日，会导致结果偏移±1天。
  // 这里统一用 moment 的 add(days) 做日历日加减。
  const step = Number(changeStep) || 0

  if (timestamp && outNewTsp) { // 直接输出 多少天前后  时间戳
    // moment 在本地时区下按日历日加减，再取回时间戳，避免跨 DST 漂移
    return moment(timestamp).add(step, 'days').valueOf()
  }

  if (timestr) {
    // timestr 形如 2019-09-20，代表一个"日历日"，按本地日历日加减
    const m = moment(timestr, 'YYYY-MM-DD').add(step, 'days')

    const year = m.year()
    const month = m.month() + 1
    const day = m.date()

    if (mode == 0) {    // 例子 2019-09-20
      return year + '-' + formateNumber(month) + '-' + formateNumber(day)
    } else if (mode == 1) {   // 例子 2019年9月20日
      return year + '年' + (!addZero ? month : formateNumber(month)) + '月' + (!addZero ? day : formateNumber(day)) + '日'
    }
  }

  if (timestamp && (mode == 0)) {  // 例子 2019-09-20
    const m = moment(timestamp).add(step, 'days')

    const year = m.year()
    const month = m.month() + 1
    const day = m.date()

    return year + '-' + formateNumber(month) + '-' + formateNumber(day)
  }
}

function getAuth () {
  const token = Vue.prototype.$cookies.get('token'),
    auth = 'Basic ' + btoa(token + ':')

  console.log(auth)

  return auth
}

// 获取时区的字符串 类似 Asia/shanghai
function findTimeZoneName () {
  const oldIntl = window.Intl
  try {
    window.Intl = undefined
    const tz = jstz.determine().name()
    window.Intl = oldIntl
    return tz
  } catch (e) {
    // sometimes (on android) you can't override intl
    return jstz.determine().name()
  }
}

// 获取唯一MD5Key 给请求打上key
function getUniqueMD5 () {
  return createMD5((new Date()).valueOf().toString() + Math.random() * 100000)
}

function transferAmount2yuan ({amount, integerSaveDecimal = false, onlyPositive = true, widthSymbol = false }) { // integerSaveDigit
  let yuan = ''
  if (isNaN(amount)) {
    return yuan
  } else {
    if (onlyPositive && (amount < 0)) {
      amount = -amount
    }
    if (!integerSaveDecimal) {
      yuan = amount % 100 ? (amount / 100).toFixed(2) : amount / 100
    } else {
      yuan = (amount / 100).toFixed(2)
    }

    if (widthSymbol) { // 正数 带上 +  负数 自身有 -
      yuan = amount > 0 ? '+' + yuan : yuan
    }

    return yuan
  }
}

// 获取token 开始上传图片
function uploadFile (fileMD5, fileType, { file, elUploadOption }, bucket = 'manban-admin') {
  return new Promise((resolve, reject) => {
    getUploadSTSToken(setDefaultErr, getAuthorizationWithOrgId()).then(async ({ errMsg, sTSToken }) => {
      if (errMsg === 'ok') {
        let OSS
        try {
          OSS = await getAliOSSModule()
        } catch (e) {
          reject(e)
          return
        }
        if (!OSS) {
          reject(new Error('ali-oss load failed'))
          return
        }

        console.log(sTSToken, 'sTSToken')
        const useBucket = bucket === 'manban-face' ? 'manban-face' : sTSToken.bucket || bucket
        // 跟进orgid来区分是否需要oss传输加速  解决国外用户上传下载问题
        const orgid = VueCookies.get('orgid') || 0
        const clientOptions = {
          region: 'oss-cn-beijing',
          accessKeyId: sTSToken.AccessKeyId, // 自己账户的accessKeyId
          accessKeySecret: sTSToken.AccessKeySecret, // 自己账户的accessKeySecret
          stsToken: sTSToken.SecurityToken,
          authorizationV4: true,
          bucket: useBucket // bucket名字
        }
        if (overseasOrgid.includes(Number(orgid))) {
          clientOptions.endpoint = 'oss-accelerate.aliyuncs.com'
        }
        const client = new OSS(clientOptions)
        console.log(fileType, '看看fileType')
        const uploadOptions = {
          progress: function (p, checkpoint) {
            console.log(p, 'progress point')
            elUploadOption.onProgress({ percent: Math.floor(p * 100), file }) // 触发el-upload组件的onProgress方法
          },
          mime: fileType,
          headers: elUploadOption.headers || {}
          // mime: 'multipart/form-data'
        }
        try {
          const fileBuffer = await fileToArrayBuffer(file)
          const file_sha1 = new JsSHA1('SHA-1', 'ARRAYBUFFER').update(fileBuffer).getHash('HEX')
          const isFind = await findAttachments(file_sha1, useBucket)
          if (isFind) {
            resolve({name: isFind})
            return
          }

          const base64Md5 = createMD5.base64(fileBuffer)
          if (base64Md5) {
            uploadOptions.headers['Content-MD5'] = base64Md5
            uploadOptions.callback = await getOssCallbackOption(fileType, file, file_sha1)
            if (!uploadOptions.callback) {
              reject()
              return
            }
          }
        } catch (e) {
          reject(e)
          throw new Error(e)
        }
        console.log(uploadOptions, 'uploadFile uploadOptions')
        client.put(fileMD5, file, uploadOptions).then((res) => {
          if (res && res.res && (res.res.statusCode === 200 || res.res.statusCode === 200)) {
            resolve(res)
            if (elUploadOption.onProgress) {
              elUploadOption.onProgress({ percent: 100, file })
            }
          } else {
            reject(res)
            window.__bl && window.__bl.error({name: '上传失败client.put', message: JSON.stringify(res)}, {
              filename: 'tools/util.js',
              lineno: 450,
              colno: 0
            })
          }
        }, (err) => {
          if (typeof setDefaultErr === 'function') {
            const default_err = setDefaultErr()
          }

          console.log(err, 'err')
          // Message({
          //   type: 'error',
          //   message: err.body && err.body.error ? err.body.error : default_err,
          //   customClass: 'manban-toast__error'
          // });
          reject(err)
        })

        // client.put(fileMD5, file, {
        //   ContentType: fileType
        // }).then((res) => {
        //   resolve(res);
        // }, (err) => {
        //   const default_err = setDefaultErr();

        //   console.log(err, 'err')
        //   // Message({
        //   //   type: 'error',
        //   //   message: err.body && err.body.error ? err.body.error : default_err,
        //   //   customClass: 'manban-toast__error'
        //   // });
        //   reject(err);
        // })
      } else {
        reject({
          errMsg
        })
      }
    }, (err) => {
      reject(err)
    })
  })
}
async function getOssCallbackOption (fileType, file, fileSha1) {
  const {Authorization, token} = getAuthorizationWithOrgId()
  if (!token) {
    return false
  }
  const file_type = fileType.split('/')[0] || 'file'
  // eslint-disable-next-line one-var
  let videoWidth, videoHeight, videoDuration = 0
  if (file_type === 'video') {
    try {
      const res = await getVideoInfo(file)
      console.log(res.videoWidth, res.videoHeight, res.duration, 'getVideoInfo')
      videoWidth = typeof res.videoWidth === 'number' ? res.videoWidth : 0
      videoHeight = typeof res.videoHeight === 'number' ? res.videoHeight : 0
      videoDuration = typeof res.duration === 'number' ? parseInt(res.duration) : 0
    } catch (e) {
      console.log(e)
    }
  }
  const xF = `"x:file_type":"${file_type}",`
  const xA = `"x:authorization":"${Authorization}",`
  const xSha1 = `"x:origin_sha1":"${fileSha1}"`
  const ImgInfo = '"imageInfo.height":"${imageInfo.height}","imageInfo.width":"${imageInfo.width}","imageInfo.format":${imageInfo.format},'
  const xWH = `"x:width":"${videoWidth}","x:height":"${videoHeight}","x:duration":"${videoDuration}",`
  let callbackBody = '{ "bucket":${bucket},"object":${object},"contentMd5":${contentMd5},"etag":${etag},"size":${size},"mimeType":${mimeType},"x:user_type":"manban_user","x:platform":"pc",INFO}'

  if (file_type === 'image') {
    callbackBody = callbackBody.replace('INFO', ImgInfo + xF + xA + xSha1)
  } else if (file_type === 'video') {
    callbackBody = callbackBody.replace('INFO', xWH + xF + xA + xSha1)
  } else {
    callbackBody = callbackBody.replace('INFO', xF + xA + xSha1)
  }
  return {
    url: getBaseUrl() + '/oss/upload/callback',
    body: callbackBody,
    contentType: 'application/json',
    file_type
  }
}
function getVideoInfo (file) {
  return new Promise(function (resolve, reject) {
    const videoElem = document.createElement('video')
    const dataUrl = URL.createObjectURL(file)
    // 当前帧的数据是可用的
    videoElem.onloadeddata = function () {
      resolve(videoElem)
      videoElem.remove()
    }
    // 20秒不触发就失败
    setTimeout(() => {
      // reject('video 后台加载失败 20秒')
      resolve({videoWidth: 0, videoHeight: 0, duration: 0})
    }, 20000)
    videoElem.onerror = function () {
      // reject('video 后台加载失败')
      resolve({videoWidth: 0, videoHeight: 0, duration: 0})
    }
    // 设置 auto 预加载数据， 否则会出现截图为黑色图片的情况
    videoElem.setAttribute('preload', 'auto')
    videoElem.src = dataUrl
  })
}

function findAttachments (file_sha1, bucket = 'manban-admin') {
  return new Promise((resolve) => {
    ossFindAttachments((res) => {
      if (res[file_sha1]) {
        resolve(res[file_sha1])
      } else {
        resolve(false)
      }
    }, {file_sha1_keys: [file_sha1], bucket}, e => {
      throw e
    })
  })
}

// 获取token  批量上传图片
/**
 * @param {String} fileMD5 传入文件MD5
 * @param {String} fileType 传入文件类型
 * @param {Object} file 传入的文件数据
 */
// 获取token 开始上传图片
function uploadBatchFile (fileMD5, fileType, { file, elUploadOption }) {
  const setDefaultErr = ''
  return new Promise((resolve, reject) => {
    getUploadSTSToken(setDefaultErr).then(async ({ errMsg, sTSToken }) => {
      if (errMsg === 'ok') {
        let OSS
        try {
          OSS = await getAliOSSModule()
        } catch (e) {
          reject(e)
          return
        }
        if (!OSS) {
          reject(new Error('ali-oss load failed'))
          return
        }

        console.log(sTSToken, 'sTSToken')

        const size = file.size
        // 跟进orgid来区分是否需要oss传输加速  解决国外用户上传下载问题
        const orgid = VueCookies.get('orgid') || 0
        const useBucket = sTSToken.bucket || 'manban-admin'
        const clientOptions = {
          region: 'oss-cn-beijing',
          accessKeyId: sTSToken.AccessKeyId, // 自己账户的accessKeyId
          accessKeySecret: sTSToken.AccessKeySecret, // 自己账户的accessKeySecret
          stsToken: sTSToken.SecurityToken,
          authorizationV4: true,
          bucket: useBucket // bucket名字
        }
        if (overseasOrgid.includes(Number(orgid))) {
          clientOptions.endpoint = 'oss-accelerate.aliyuncs.com'
        }
        const client = new OSS(clientOptions)

        const uploadOptions = {
          progress: function (p, checkpoint) {
            console.log(p, 'progress point')
            elUploadOption.onProgress({ percent: Math.floor(p * 100), file }) // 触发el-upload组件的onProgress方法
          },
          headers: {

          }
        }

        if (elUploadOption.headers && elUploadOption.headers['Content-Type']) {
          uploadOptions.headers = { ...(elUploadOption.headers || {})}
          uploadOptions.mime = fileType
        }
        try {
          const fileBuffer = await fileToArrayBuffer(file)
          const file_sha1 = new JsSHA1('SHA-1', 'ARRAYBUFFER').update(fileBuffer).getHash('HEX')
          const isFind = await findAttachments(file_sha1, useBucket)
          if (isFind) {
            resolve({name: isFind})
            if (elUploadOption.onProgress) {
              elUploadOption.onProgress({ percent: 100, file })
            }
            return
          }
          const base64Md5 = createMD5.base64(fileBuffer)
          if (base64Md5) {
            uploadOptions.headers['Content-MD5'] = base64Md5
            uploadOptions.callback = await getOssCallbackOption(fileType, file, file_sha1)
            if (!uploadOptions.callback) {
              reject()
              return
            }
          }
        } catch (e) {
          reject(e)
          throw new Error(e)
        }
        // if (true){
        //   resolve({})
        //   if (elUploadOption.onProgress) {
        //     elUploadOption.onProgress({ percent: 100, file })
        //   }
        //   return;
        // }

        console.log(uploadOptions, 'uploadBatchFile uploadOptions')

        client.put(fileMD5, file, uploadOptions).then((res) => {
          console.log(res, '正常成功的结果')
          if (res && res.res && (res.res.statusCode === 200 || res.res.statusCode === 200)) {
            resolve(res)
            if (elUploadOption.onProgress) {
              elUploadOption.onProgress({ percent: 100, file })
            }
          } else {
            reject(res)
            window.__bl && window.__bl.error({name: '上传失败client.put', message: JSON.stringify(res)}, {
              filename: 'tools/util.js',
              lineno: 650,
              colno: 0
            })
          }
        }, (err) => {
          // const default_err = setDefaultErr();

          console.log(err, 'err')
          // Message({
          //   type: 'error',
          //   message: err.body && err.body.error ? err.body.error : default_err,
          //   customClass: 'manban-toast__error'
          // });
          reject(err)
        })
      }
    })
  })
}

// 富文本上传图片
function uploadRichTextEditorFile (fileMD5, fileType, file) {
  return new Promise((resolve, reject) => {
    getUploadSTSToken(setDefaultErr, getAuthorizationWithOrgId()).then(async ({ errMsg, sTSToken }) => {
      if (errMsg === 'ok') {
        let OSS
        try {
          OSS = await getAliOSSModule()
        } catch (e) {
          reject(e)
          return
        }
        if (!OSS) {
          reject(new Error('ali-oss load failed'))
          return
        }

        console.log(sTSToken, 'sTSToken')

        // 跟进orgid来区分是否需要oss传输加速  解决国外用户上传下载问题
        const orgid = VueCookies.get('orgid') || 0
        const useBucket = sTSToken.bucket || 'manban-admin'
        const clientOptions = {
          region: 'oss-cn-beijing',
          accessKeyId: sTSToken.AccessKeyId, // 自己账户的accessKeyId
          accessKeySecret: sTSToken.AccessKeySecret, // 自己账户的accessKeySecret
          stsToken: sTSToken.SecurityToken,
          authorizationV4: true,
          bucket: useBucket // bucket名字
        }
        if (overseasOrgid.includes(Number(orgid))) {
          clientOptions.endpoint = 'oss-accelerate.aliyuncs.com'
        }
        const client = new OSS(clientOptions)

        const uploadOptions = {
          mime: fileType,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        try {
          const fileBuffer = await fileToArrayBuffer(file)
          const file_sha1 = new JsSHA1('SHA-1', 'ARRAYBUFFER').update(fileBuffer).getHash('HEX')
          const isFind = await findAttachments(file_sha1, useBucket)
          if (isFind) {
            resolve({name: isFind})
            return
          }
          const base64Md5 = createMD5.base64(fileBuffer)
          if (base64Md5) {
            uploadOptions.headers['Content-MD5'] = base64Md5
            uploadOptions.callback = await getOssCallbackOption(fileType, file, file_sha1)
            if (!uploadOptions.callback) {
              reject()
              return
            }
          }
        } catch (e) {
          reject(e)
          throw new Error(e)
        }
        client.put(fileMD5, file, uploadOptions).then((res) => {
          if (res && res.res && (res.res.statusCode === 200 || res.res.statusCode === 200)) {
            resolve(res)
          } else {
            reject(res)
            window.__bl && window.__bl.error({name: '上传失败client.put', message: JSON.stringify(res)}, {
              filename: 'tools/util.js',
              lineno: 750,
              colno: 0
            })
          }
        }, (err) => {
          console.log(err, 'err')

          reject(err)
        })
      } else {
        reject({
          errMsg
        })
      }
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * @param {Object} file 文件对象
 */
function getFileMD5 (file, create_time) {
  // console.log(file, create_time, 'file, create_time')
  return new Promise((resolve, reject) => {
    const rawFile = file && file.raw ? file.raw : file
    const uid = (file && file.uid) || (file && file.raw && file.raw.uid) || ''
    if (!rawFile || typeof FileReader === 'undefined') {
      reject({
        msg: 'invalid',
        error: new Error('file is empty or FileReader missing'),
        uid,
        md5: '',
        create_time
      })
      return
    }

    const fileReader = new FileReader()

    // 异步执行函数
    fileReader.onload = function (e) {
      try {
        const md5 = createMD5(e.target.result)
        resolve({
          msg: 'ok',
          uid,
          md5,
          create_time
        })
      } catch (error) {
        reject({
          msg: 'error',
          error,
          uid,
          md5: '',
          create_time
        })
      }
    }

    // 被中断时
    fileReader.onabort = function (e) {
      reject({
        msg: 'absort',
        error: e,
        uid,
        md5: '',
        create_time
      })
    }

    // 发生错误时
    fileReader.onerror = function (e) {
      reject({
        msg: 'error',
        error: e,
        uid,
        md5: '',
        create_time
      })
    }

    // 获取文件二进制数据
    try {
      fileReader.readAsArrayBuffer(rawFile)
    } catch (e) {
      reject({
        msg: 'error',
        error: e,
        uid,
        md5: '',
        create_time
      })
    }
  })
}
function fileToArrayBuffer (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })
}

function judgeWhetherItFromManban (url) {
  const pattern = /^(([^:/?#]+):)?\/\/(([^/?#]+):(.+)@)?([^/?#:]*)(:(\d+))?([^?#]*)(\\?([^#]*))?(#(.*))?/
  const matches = url.match(pattern)
  const hostname = (Array.isArray(matches) && matches.length > 6) ? matches[6] : ''
  const JUDGEFROMMANBAN = ['manbanapp.com', 'manbanapp.cn']

  const judge_whether_it_from_manban = JUDGEFROMMANBAN
  let i = 0
  for (i = 0; i < judge_whether_it_from_manban.length; i++) {
    if (hostname.endsWith('.' + judge_whether_it_from_manban[i]) || hostname === judge_whether_it_from_manban[i]) {
      break
    }
  }
  if (i >= judge_whether_it_from_manban.length) {
    console.log('文档不来自manban')
    return false
  }
  return true
}

/**
 *
 * @param {String} url
 */

function getMD5ByURL (url) {
  if (typeof url !== 'string') {
    throw new TypeError('url should be String, but url is' + typeof url)
    // return ''
  }

  // const imgHost = `https://pacc.manbanapp.cn`
  const JUDGEFROMMANBAN = ['manbanapp.com', 'manbanapp.cn']

  // if (url.startsWith(imgHost)) {
  const pattern = /^(([^:/?#]+):)?\/\/(([^/?#]+):(.+)@)?([^/?#:]*)(:(\d+))?([^?#]*)(\\?([^#]*))?(#(.*))?/
  const matches = url.match(pattern)
  const hostname = matches[6]

  const judge_whether_it_from_manban = JUDGEFROMMANBAN
  let i = 0
  for (i = 0; i < judge_whether_it_from_manban.length; i++) {
    if (hostname.endsWith('.' + judge_whether_it_from_manban[i]) || hostname === judge_whether_it_from_manban[i]) {
      break
    }
  }
  if (i >= judge_whether_it_from_manban.length) {
    console.log('文档不来自manban')
    return ''
  } else {
    const startMD5Index = url.lastIndexOf('/')

    const MD5 = url.slice(startMD5Index + 1)

    return MD5
  }
  // else {
  //   return ''
  // }
}

// 暂时不用
// function showPageLoading( { _this, options } ) {
//   return _this.$loading(options).close
// }

function normalizeExpireMonthDay (monthDay) {
  const matched = /^(\d{1,2})-(\d{1,2})$/.exec(`${monthDay || ''}`.trim())
  if (!matched) {
    return ''
  }
  const month = parseInt(matched[1])
  const day = parseInt(matched[2])
  if (!month || !day || month < 1 || month > 12 || day < 1 || day > 31) {
    return ''
  }
  return `${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
}

function getSpecExpireText (spec = {}) {
  const expireStartMonthDay = normalizeExpireMonthDay(spec.expire_start_month_day)
  const expireMonthDay = normalizeExpireMonthDay(spec.expire_month_day)
  if (spec.expire_mode === 'date' && expireStartMonthDay && expireMonthDay) {
    const [startMonth, startDay] = expireStartMonthDay.split('-')
    const [month, day] = expireMonthDay.split('-')
    return `（有效期每年${parseInt(startMonth)}月${parseInt(startDay)}日至${parseInt(month)}月${parseInt(day)}日）`
  }
  if (spec.expire_days) {
    return `（有效期${spec.expire_days}天）`
  }
  return ''
}

function getSpecValueStr ({ spec, mode = 'class_hour', widthPrice = false }) {
  const expireText = getSpecExpireText(spec)
  switch (mode) {
    case 'class_hour':
      spec.value_str = `${(spec.class_hour - 0).toFixed(1)}课时${spec.free_count ? `送${spec.free_count}课时` : ''}${expireText}`
      break
    case 'duration':
      spec.value_str = `${spec.days}天${spec.free_count ? `送${spec.free_count}天` : ''}${expireText}`
      break
    case 'fee':
      // spec.value_str = `${(spec.yuan - 0).toFixed(2)}元储值`
      spec.value_str = `储值${(spec.yuan - 0).toFixed(2)}`

      if (spec.extra_yuan) {
        spec.value_str += `送${(spec.extra_yuan - 0).toFixed(2)}`
      }

      spec.value_str += `${expireText}`
      break
  }

  if (
    widthPrice &&
    spec.price
  ) {
    spec.value_str += ` /${spec.price}元`
  }

  return spec
}

function getOrgId () {
  let current_orgid = Vue.prototype.$cookies.get('orgid')

  return {
    org_id: current_orgid
  }
}

function getAuthorizationWithOrgId () {
  const token = Vue.prototype.$cookies.get('token')

  return {
    Authorization: `Basic ` + btoa(token + ':' + getOrgId().org_id),
    token
  }
}

// function getAuthorization(){
//   const token = Vue.prototype.$cookies.get('token');

//   return {
//     Authorization: `Basic `+ btoa( token)
//   };
// }

function setDefaultErr () {
  let err_msg = window.__default_err_msg

  err_msg = err_msg || '登录失效，请重新登录'

  console.log(err_msg, 'err_msg')

  return err_msg
}

function getExistKeyParams ({ cur_params, targetForm, allExistKeys }) {
  cur_params = cur_params || {}
  if (!Array.isArray(allExistKeys)) { return new TypeError('allExistKeys should be Array') }

  allExistKeys.forEach((key, index) => {
    if (typeof targetForm[key] === 'object' && (targetForm[key] !== null)) {
      if (Array.isArray(targetForm[key])) {
        if (key == 'mobiles') {
          targetForm[key].filter((item) => (item.mobile != ''))
        }

        targetForm[key].length && (cur_params[key] = targetForm[key])
      } else {
        Object.entries(targetForm[key]).length && (cur_params[key] = targetForm[key])
      }
    } else {
      targetForm[key] && (cur_params[key] = targetForm[key])
    }
  })

  return cur_params
}

function smallImageURL (originURL, width, height, isCut = true) {
  if (!originURL) {
    return ''
  }
  const scale = window.devicePixelRatio >= 2.5 ? 3 : 2

  let processedURL
  const params = []
  const actualWidth = Math.round(width * scale)
  const actualHeight = Math.round(height * scale)
  const resizeMode = isCut ? 'm_fill' : 'm_lfit'
  params.push(`resize${actualWidth ? ',w_' + actualWidth : ''}${actualHeight ? ',h_' + actualHeight : ''},${resizeMode}`)
  params.push(`quality,q_95`)
  params.push(`format,webp`)

  const processParams = `${params.join('/')}`
  if (originURL.includes('?')) {
    processedURL = `${originURL},${processParams}`
  } else {
    processedURL = `${originURL}?x-oss-process=image/${processParams}`
  }
  return processedURL
}

// isObject   不是  null或者  array
function isObject (val) {
  return (val != null && typeof val === 'object' && Array.isArray(val) === false)
}

// 将十六进制 颜色 转换为  rgba
function transferColorFormHex (hexColor, alpha = 1) {
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = hexColor.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //  处理六位的颜色值
    var sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    // 或
    return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
  } else {
    return sColor
  }
}

// 200000000分     2,000,000.00
function handlerMomeny ({ amount, split_symbol = ',' }) {
  let new_amount = ''

  // if(amount < 0) {
  //   amount = -amount;
  // }

  // Number.prototype.toLocaleString('en-GB') locales
  //  同样可以使用toLocaleString 代替 Intl.NumberFormat 方法

  // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
  if (
    typeof amount === 'number'
  ) {
    if (
      Intl &&
      Intl.NumberFormat
    ) {
      const new_amount_str = (new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 2 // 使用的小数位数的最小数目.
      }).format((amount / 100)))

      // locales  https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Intl#Locale_identification_and_negotiation

      console.log(new_amount_str, 'new_amount_str')

      console.log(typeof new_amount_str, 'typeof new_amount_str')

      return new_amount_str
    } else if (typeof Number.prototype.toLocaleString === 'function') {
      const new_amount_str = amount.toLocaleString('en-GB', {
        minimumFractionDigits: 2 // 使用的小数位数的最小数目.
      })

      return new_amount_str
    }
  }

  if ((amount + '').length <= 2) {
    return amount / 100 + ''
  }

  let decimals = amount % 100

  decimals = ((decimals + '').length < 2 ? '0' + decimals : decimals)

  let integers = Math.floor(amount / 100)

  // console.log('decimals', decimals, 'integers', integers);

  let integers_len = (integers + '').length

  if (integers_len <= 3) {
    new_amount = integers + '.' + decimals

    return new_amount
  }

  // console.log('integers', integers);

  const createZeroStr = (zero_num) => {
    let str = ''

    for (let i = 0; i < zero_num; i++) {
      str += '0'
    }

    return str
  }

  const loop = (integers) => {
    let divide_1000 = Math.floor(integers / 1000)

    let remainder = (((integers % 1000) + '').length < 3 ? createZeroStr(3 - ((integers % 1000) + '').length) + (integers % 1000) : (integers % 1000))
    if (divide_1000) {
      if ((divide_1000 + '').length > 3) {
        loop(divide_1000)

        new_amount += split_symbol + remainder
      } else {
        new_amount += divide_1000 + split_symbol + remainder
      }
    }
  }

  loop(integers)

  return new_amount + '.' + decimals
}

//  计算文件内容单位  KB  MB  GB  TB
function handlerMemorySpace ({ size, startUnit = 'KB' }) {
  let unit = [ 'B', 'KB', 'MB', 'GB', 'TB']

  let startUnitIndex = unit.findIndex((item) => (item == startUnit))

  if (startUnitIndex == -1) {
    return new Error('未传入正确单位')
  } else if (startUnitIndex > 4) {
    return new Error('超出计算范围，最大TB')
  }
  let loop = (size) => {
    let integer_part = Math.floor(size / 1024)

    let decimal_part = size % 1024

    if (integer_part >= 1) {
      startUnitIndex++

      if (startUnitIndex > 4) {
        return new Error('超出计算范围，最大TB')
      }
    }

    if (integer_part > 1024) {
      loop(integer_part)
    } else {
      return integer_part + '.' + (decimal_part < 100 ? decimal_part : (decimal_part / 100).toFixed(2)) + unit[startUnitIndex]
    }
  }

  if (size > 1024) {
    return loop(size)
  } else {
    return size + startUnit
  }
}

// 颜色 相对应的 浅色或者深色 col #fff  amt  -10  10
function lightenDarkenColor (col, amt) {
  var usePound = false

  if (col[0] == '#') {
    col = col.slice(1)
    usePound = true
  }

  var num = parseInt(col, 16)

  var r = (num >> 16) + amt

  if (r > 255) r = 255
  else if (r < 0) r = 0

  var b = ((num >> 8) & 0x00FF) + amt

  if (b > 255) b = 255
  else if (b < 0) b = 0

  var g = (num & 0x0000FF) + amt

  if (g > 255) g = 255
  else if (g < 0) g = 0

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
}

// 获取 x-y  step 的 数组
function getArrayFromToByStep ({ start, end, step }) {
  let arr = []
  if (end < start) { return [] }

  for (let i = start; i <= end; i += step) {
    arr.push(i)
  }

  return arr
}

// 使用旧数据赋值
// 保留旧数据
function refreshOldData (vm, pageName, cb) {
  const store_data_list = vm.store_data_list

  console.log(store_data_list, 'store_data_list')

  const cache_obj = vm.store_data_list.get(pageName)

  console.log(cache_obj, 'cache_obj')

  if (!store_data_list.has(pageName) && !cache_obj) {
    return false
  }

  const { data: store_data, props: store_props } = cache_obj
  // const { data: store_data, props: store_props } = await this.$store.dispatch('storeCache/getCacheData', 'signup');

  console.log(store_props, 'store_props', store_data, 'store_data')

  // console.log(vm.manban_loading, vm.store_props, vm.store_data, 'props, store data')
  // const store_props = vm.store_props || [];

  // const store_data = vm.store_data || {};

  typeof cb === 'function' && cb({ vm, store_props, store_data })
}

function pc_option_system () {
  // 平台、设备和操作系统
  let system = {
    win: false,
    mac: false,
    xll: false
  }
  // 检测平台
  let p = window.navigator.platform
  let agent = window.navigator.userAgent
  system.win = p.indexOf('Win') == 0
  system.mac = p.indexOf('Mac') == 0 && !('ontouchend' in document)
  system.x11 = (p == 'X11') || (p.indexOf('Linux') == 0)

  console.log(p, system)
  // alert(agent);
  if (system.win || system.mac || system.xll) {
    // PC端
    if (system.win) {
      return 1 // window
    } else if (system.mac) {
      return 2 // mac
    } else {
      // this.$message({
      //   type: 'info',
      //   message: '仅支持window和mac操作系统',
      //   customClass: 'manban-toast__info'
      // });

      return null // error
    }
  } else {
    // this.$message({
    //   type: 'info',
    //   message: '请在电脑端下载客户端',
    //   customClass: 'manban-toast__info'
    // });

    return 0  // 移动端
      // 移动端跳转的链接
      // alert('现在是手机');
  }
}

// 判断 是在 PC 移动端、ipad
function judgePlatForm () {
  // 平台、设备和操作系统
  let system = {
    win: false,
    mac: false,
    ipad: false,
    xll: false
  }
  // 检测平台
  let p = window.navigator.platform
  let agent = window.navigator.userAgent
  system.win = p.indexOf('Win') == 0
  system.mac = p.indexOf('Mac') == 0 && !('ontouchend' in document)
  system.ipad = !!(agent.match(/(iPad).*OS\s([\d_]+)/i)) || (p.indexOf('Mac') == 0)
  system.x11 = (p == 'X11') || (p.indexOf('Linux') == 0)

  console.log(p, system)
  // alert(agent);
  if (system.win || system.ipad || system.mac || system.xll) {
    // PC端
    if (system.win) {
      return 1 // window
    } else if (system.mac) { // && !system.ipad
      return 2 // mac
    } else if (system.ipad) {
      // this.$message({
      //   type: 'info',
      //   message: '仅支持window和mac操作系统',
      //   customClass: 'manban-toast__info'
      // });

      return 3 // ipad
    } else {
      return null // error
    }
  } else {
    // this.$message({
    //   type: 'info',
    //   message: '请在电脑端下载客户端',
    //   customClass: 'manban-toast__info'
    // });

    return 0  // 移动端
      // 移动端跳转的链接
      // alert('现在是手机');
  }
}

function wechatBrowserWarn (infoText = '在微信内打开可能无法下载文件，请复制链接到浏览器中打开！') {
  // 判断是否在微信浏览器中打开
  let ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/wxwork/i) == 'wxwork') {
    if (window.myapp && window.myapp.$message) {
      try {
        window.myapp.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: infoText,
          customClass: 'manban-toast__warning',
          showClose: true,
          duration: 0
        })
      } catch (error) {
        alert(infoText)
      }
    } else {
      alert(infoText)
    }
  }
}
// a 标签触发跳转
function jumpUrlByA ({ url }) {
  let a = document.createElement('a')

  // let param_str = '';

  // for(let key in downloadParam) {
  //   param_str += key + '=' + downloadParam[key] + '&';
  // }

  // param_str = param_str.slice(0, param_str.length - 1);

  // url += '?' + param_str;

  a.setAttribute('href', url)

  a.setAttribute('target', '_blank')  // _top  _blank

  // // 注意：下载的地址域名和访问网站的域名是同源  否则设置无效
  // if (fileName) { // 设置文件名
  //   a.setAttribute("download", fileName);
  // }

  console.log(a, 'download a 标签')

  // frame.setAttribute('src', url);

  a.rel = 'nofollow noopener noreferrer'

  let theEvent = document.createEvent('Events')

  // document.getElementById("aaa").dispatchEvent(theEvent);

  document.body.appendChild(a)
  // a.click();
  if (a.click) {
    a.click()

    console.log('触发 click')
  } else if (a.dispatchEvent && theEvent && (pc_option_system() === 0)) {
    theEvent.initEvent('touchstart', true, true)
    a.dispatchEvent(theEvent)

    console.log('触发 touch')
  } else {
    window.open(url, '_blank')

    console.log('触发 window open')
  }

  document.body.removeChild(a)
}
// a 标签触发下载请求
function triggerDownloadAPI ({ url, downloadParam, fileName }) {
  let a = document.createElement('a')

  let param_str = ''

  for (let key in downloadParam) {
    param_str += key + '=' + downloadParam[key] + '&'
  }

  param_str = param_str.slice(0, param_str.length - 1)

  url += '?' + param_str

  a.setAttribute('href', url)

  a.setAttribute('target', '_top')  // _top  _blank

  // 注意：下载的地址域名和访问网站的域名是同源  否则设置无效
  if (fileName) { // 设置文件名
    a.setAttribute('download', fileName)
  }

  console.log(a, 'download a 标签')

  // frame.setAttribute('src', url);

  a.rel = 'nofollow noopener noreferrer'

  let theEvent = document.createEvent('Events')

  // document.getElementById("aaa").dispatchEvent(theEvent);

  document.body.appendChild(a)
  // a.click();
  if (a.click) {
    a.click()

    console.log('触发 click')
  } else if (a.dispatchEvent && theEvent && (pc_option_system() === 0)) {
    theEvent.initEvent('touchstart', true, true)
    a.dispatchEvent(theEvent)

    console.log('触发 touch')
  } else {
    window.open(url, '_top')

    console.log('触发 window open')
  }

  document.body.removeChild(a)
}

function triggerDownloadFileByEnd ({ url, downloadParam, fileName, cb, failCb }) {
  // 跟进orgid来区分是否需要oss传输加速  解决国外用户上传下载问题
  let orgid = VueCookies.get('orgid') || 0
  if (overseasOrgid.includes(Number(orgid))) {
    if (url.startsWith('https://p.manbanapp.cn/')) { url = url.replace(/p.manbanapp.cn/, 'manban-admin.oss-accelerate.aliyuncs.com') }
  }

  getFileArrayBuffer(url, downloadParam, (res) => {
    downloadExcelByA(res.body, fileName, cb)
  }, () => {
    Message({
      type: 'info',
      message: '文档下载失败，请稍候重试',
      customClass: 'manban-toast__info'
    })
    if (failCb) {
      failCb()
    }
  })
}

// 通过a 下载
function downloadExcelByA (blob_data, filename = '测试.xlsx', cb) {
  wechatBrowserWarn()

  let a = document.createElement('a')

  // frame.setAttribute('src', url);

  let new_blob = new Blob([blob_data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

  if ((!!window.ActiveXObject || 'ActiveXObject' in window) && window.navigator && window.navigator.msSaveOrOpenBlob) { // 判断是不是ie的浏览器
    window.navigator.msSaveOrOpenBlob(new_blob, filename)
    cb && cb()
    return
  }
  // 引入saveAs尝试解决safari浏览器无法下载的问题，无法验证
  // saveAs(new_blob, filename);
  // return;
  // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
  // application/vnd.ms-excel
  const objectUrl = window.URL.createObjectURL(new_blob)
  console.log('window.URL.createObjectURL(new_blob)', objectUrl)

  a.setAttribute('href', objectUrl)

  a.rel = 'nofollow noopener noreferrer'

  let theEvent = document.createEvent('Events')

    // document.getElementById("aaa").dispatchEvent(theEvent);

  document.body.appendChild(a)
  // a.click();
  if (!('download' in document.createElement('a'))) {
    window.navigator.msSaveBlob(bolb, filename)
  } else {
    a.setAttribute('download', filename)

    if (a.click) {
      a.click()

      console.log('触发 click')
    } else if (a.dispatchEvent && theEvent && (pc_option_system === 0)) {
      theEvent.initEvent('touchstart', true, true)
      a.dispatchEvent(theEvent)

      console.log('触发 touch')
    }
  }
  setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 0)

  document.body.removeChild(a)
  cb && cb()
}
// 通过 a 下载图片
function downloadPicURLByA (img_url, filename = '测试.xlsx', successCb = null) {
  if (!img_url) { return false }
  let a = document.createElement('a')

  a.setAttribute('target', '_top')  // _top  _blank

  // frame.setAttribute('src', url);

  // let new_blob = new Blob([blob_data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
  // application/vnd.ms-excel

  a.setAttribute('href', img_url)

  a.setAttribute('download', img_url)

  a.rel = 'nofollow noopener noreferrer'

  let theEvent = document.createEvent('Events')

    // document.getElementById("aaa").dispatchEvent(theEvent);

  document.body.appendChild(a)
  // a.click();
  if (!('download' in document.createElement('a'))) {
    window.navigator.msSaveBlob(bolb, filename)
  } else {
    a.setAttribute('download', filename)

    if (a.click) {
      a.click()

      console.log('触发 click')
    } else if (a.dispatchEvent && theEvent && (pc_option_system === 0)) {
      theEvent.initEvent('touchstart', true, true)
      a.dispatchEvent(theEvent)

      console.log('触发 touch')
    }
  }
  window.URL.revokeObjectURL(a.href)

  document.body.removeChild(a)

  if (typeof successCb === 'function') {
    successCb()
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone (source) {
  if (typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  if (!source || !source.constructor) { // 当为 null source.constructor会报错
    return source
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
/**
 *
 * @param {String} text
 */
function filterTextMaxLen (text, maxLen = 30) {
  if (typeof text !== 'string') { return text }

  if (typeof maxLen !== 'number') {
    maxLen = 30
  }

  const len = text.length

  if (len < maxLen) { return text }

  return `${text.slice(0, maxLen)}...`
}

/**
 *
 * @param {*} propObject
 * @param {*} exitPossibleProp
 * @param {*} commonError
 */
function curryingFunction (fn, len) {
  len = len || fn.length
  return function (...rest) {
    return rest.length > len ? fn.call(this, rest) : curryingFunction(currying.apply(this, [fn].concat(rest)), length - rest.length)
  }
}

/**
 * 通用柯里化
 */
function currying (fn, ...rest1) {
  return function (...rest2) {
    return fn.apply(null, rest1.concat(rest2))
  }
}

/**
 *
 * @param {Object} propObject （element-ui） form.validate()  函数第二个参数， 所有未通过验证的字段 结构类似 { key: [Error] }
 * @param {Array} exitPossibleProp 可能会无法通过校验的字段， 主要是自定义校验的字段，通用的 required  带 * 号为必填项
 */
function formValidateMessage (propObject, exitPossibleProp, commonError = '带 * 号为必填项') {
  let errMsg = commonError

  let i, len = exitPossibleProp.length

  for (i = 0; i < len; i++) {
    let prop = exitPossibleProp[i]

    const arrError = propObject[prop]

    // console.log(arrError, 'arrError');

    if (arrError && arrError.length) {
      console.log(arrError[0].message)
      errMsg = arrError[0].message

      break
    }
  }

  Message({
    type: 'error',
    message: errMsg,
    customClass: 'manban-toast__error'
  })
}

// 提交表单校验
/**
 *
 * @param {Object} Option
 *   formName: string el-form 表单的ref model 同名
 *   customValidateProps: array  el-form-item rule 有 validator 的字段
 *   success: function  验证成功回调
 *   fail: function 验证失败回调
 */
function formValidate ({
  formName,
  customValidateProps,
  success,
  fail
}) {
  const refs = this.$refs || {}

  console.log(refs, 'refs')
  const formDom = this.$refs[formName] || {}

  const formData = this[formName] || {}
  console.log(formDom, 'formDom')

  if (typeof formDom.validate === 'function') {
    formDom.validate((valid, propObject) => {
      if (valid) {
        if (typeof success === 'function') {
          success(formData)
        }
      } else {
        formValidateMessage(propObject, Array.isArray(customValidateProps) ? customValidateProps : [])

        if (typeof fail === 'function') {
          fail(propObject)
        }
        // const exitPossibleProp = ['sign_use_count', 'max_student_count'];

        // this.$emit('update:curClass', {});

        // this.manban_create_loading = false;

        return false
      }
    })
  }
}

// 手机号脱敏，从第四位开始到第七位 (少于七位则到最末即可) 替换为 *  (国内手机号、国际手机号)
function desensitizationMobile (mobile, startIndex, endIndex) {
  if (typeof mobile !== 'string') {
    return mobile
  }

  startIndex = startIndex || 3
  endIndex = endIndex || 7
  const len = mobile.length

  const repeatNumber = Math.min(len, endIndex) - startIndex

  // console.log(len, repeatNumber, 'repeatNumber')

  const mobilArr = mobile.split('')

  mobilArr.splice(startIndex, repeatNumber, '*'.repeat(repeatNumber))

  mobile = mobilArr.join('')

  // console.log(mobile, 'mobile');

  return mobile
}

function closewin () {
  if (navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) {
    console.log('窗口触发关闭 新')

    // try {
    window.open(location, '_self').close() // 如果可以触发关闭，则触发
    // } catch (error) {
    window.location.href = 'about:blank'
    window.close()
    // }
  } else {
    console.log('窗口触发关闭 旧')

    window.opener = null
    window.open('', '_self')
    window.close()
  }
}

function closePageTab () {
  if (typeof window.close === 'function') {
    closewin()
    // window.close();
  } else {
    Message({
      type: 'info',
      message: '当前浏览器不支持自动关闭标签页面，请手动关闭',
      customClass: 'manban-toast__info'
    })
  }
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
function parseTime (time, cFormat, exactSecond = false) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (((typeof time === 'number') && (time.toString().length === 10)) || exactSecond) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * 格式化"课卡日期"(开始日期/到期日)为展示字符串。
 *
 * 背景：后端返回的 start_date_ts / expire_date_ts 是按服务器时区(Asia/Shanghai)
 * 用 mktime 算出的"时刻"。在有时差/夏令时的浏览器(如纽约 UTC-4/-5)用本地方式
 * 解析这个时刻，会比真实日历日偏移 ±1 天(经典时区bug)。
 *
 * 正确做法：优先使用后端同时返回的纯日期字符串 start_date / expire_date(形如
 * "2026-09-05")，它不带时区、不会偏移。仅当字符串缺失(旧数据)时才回退用时间戳。
 *
 * @param {String} dateStr 后端返回的纯日期字符串，如 "2026-09-05"，可为空
 * @param {Number} ts      后端返回的 _ts 时间戳(秒或毫秒)，作为兜底
 * @param {String} fmt     moment 输出格式，默认 'YYYY年MM月DD日'
 * @returns {String}       格式化后的日期字符串；都为空时返回 ''
 */
function formatCardDateStr (dateStr, ts, fmt = 'YYYY年MM月DD日') {
  if (dateStr) {
    return moment(dateStr, 'YYYY-MM-DD').format(fmt)
  }
  if (ts) {
    // 兜底：旧数据无日期字符串时仍用时间戳(注意此路径在跨时区时可能仍有±1天偏移)
    let ms = ts
    if (ts.toString().length === 10) {
      ms = ts * 1000
    }
    return moment(ms).format(fmt)
  }
  return ''
}

//  trigger 为 click  hover  focus 的 popover
function closePopover ({ clickDomSelector }) {
  clickDomSelector = clickDomSelector || 'body'
  let clickDom = document.querySelector(clickDomSelector)

  let theEvent = document.createEvent('Events')

  if (clickDom.click) {
    clickDom.click()
  } else if (clickDom.dispatchEvent && theEvent) {
    theEvent.initEvent(pc_option_system() == 0 ? 'touchstart' : 'click', true, true)
    clickDom.dispatchEvent(theEvent)
  }
}

/**
 * // 限制为正整数
 * @param {String} val input 值
 * @param {Function} success 输入是限制值
 * @param {Function} fail 输入不是限制值 返回 ‘’
 */
function limitIntegetInput (val, success = null, fail = null) {
  const new_val = val ? val.toString().replace(/[^0-9]/g, '') : ''

  // console.log(new_val, new_val, isNaN(new_val))

  const actual_new_val = new_val && new_val.trim && new_val.trim() ? new_val.trim() : ''

  // console.log(actual_new_val, 'actual_new_val')

  // console.log(new_val, 'new_val')

  if (actual_new_val && (isNaN(actual_new_val) === false)) {
    typeof success === 'function' && success(actual_new_val)
  } else {
    typeof fail === 'function' && fail(val && isNaN(val) === false ? actual_new_val : '')
  }
}

/**
 * // 限制为保留两位有效小数
 * @param {String} val input 值
 * @param {Function} success 输入是限制值
 * @param {Function} fail 输入不是限制值 返回 ‘’
 */
function limitAmount2PointAfterInput (val, success = null, fail = null) {
  const new_val = val ? val.toString().replace(/[^0-9\.]/g, '') : ''

  const actual_new_val = new_val && new_val.trim && new_val.trim() ? new_val.trim() : ''

  if (actual_new_val && (isNaN(actual_new_val) === false)) {
    actual_new_val.replace(/([0-9]{1,}\.?[0-9]{0,2})/, (outer_val) => {
      console.log('replace, val', outer_val)

      typeof success === 'function' && success(outer_val)
    })
  } else {
    typeof fail === 'function' && fail(val && isNaN(val) === false ? actual_new_val : '')
  }
}

/**
 * // 限制为保留一位有效小数
 * @param {String} val input 值
 * @param {Function} success 输入是限制值
 * @param {Function} fail 输入不是限制值 返回 ‘’
 */
function limitAmount1PointAfterInput (val, success = null, fail = null) {
  const new_val = val ? val.toString().replace(/[^0-9\.]/g, '') : ''

  const actual_new_val = new_val && new_val.trim && new_val.trim() ? new_val.trim() : ''

  if (actual_new_val && (isNaN(actual_new_val) === false)) {
    actual_new_val.replace(/([0-9]{1,}\.?[0-9]{0,1})/, (outer_val) => {
      console.log('replace, val', outer_val)

      typeof success === 'function' && success(outer_val)
    })
  } else {
    typeof fail === 'function' && fail(val && isNaN(val) === false ? actual_new_val : '')
  }
}

/**
 * @param {Number} number 原数字
 * @param {Number} len 数字要保留的位数
 */
function toFixNumber (number, len) {
  if (len < 0 || len >= 20) {
    throw (new Error('数字长度不可小于0 或者大于20'))
    return number
  }

  if (typeof number !== 'number') {
    throw (new TypeError('number 必须是一个数字'))
    return number
  }

  len = len || 0

  return parseInt(number.toFixed(len))
}
// 感觉不够严谨
function judgeToPage (pc_tabs) {
  // if(pc_tabs.length === 0) {
  //   router.replace({
  //     path: '/login'
  //   })
  // } else {
  // 切换机构不跳首页呢
  if (Array.isArray(pc_tabs) && pc_tabs.length) {
    let homepage = pc_tabs[0]
    switch (homepage) {
      case 'lesson':
        router.replace({
          path: '/main/schedule'
        })
        break
      case 'class':
        router.replace({
          path: '/main/classmanagement'
        })
        break
      case 'student':
        router.replace({
          path: '/main/studentmanage'
        })
        break
      case 'student_order':
        router.replace({
          path: '/main/signup'
        })
        break
      case 'crm':
        router.replace({
          path: '/main/recruitstudent'
        })
        break
      case 'finance':
        router.replace({
          path: '/main/finance'
        })
        break
      case 'analysis':
        router.replace({
          path: '/main/statistic'
        })
        break
      case 'sales_manage':
        router.replace({
          path: '/main/salesmanage'
        })
        break
      case 'org_manage':
        router.replace({
          path: '/main/managesettings'
        })
        break
      default:

        break
    }
  }
}
// 感觉不够严谨
function judgeToPageForDredirect (pc_tabs) {
  // if(pc_tabs.length === 0) {
  //   return '/login'
  // } else {
  // 切换机构不跳首页呢
  if (Array.isArray(pc_tabs) && pc_tabs.length) {
    let homepage = pc_tabs[0]
    switch (homepage) {
      case 'lesson':
        return '/main/schedule'
        break
      case 'class':
        return '/main/classmanagement'
        break
      case 'student':
        return '/main/studentmanage'
        break
      case 'student_order':
        return '/main/signup'
        break
      case 'CRM':
        return '/main/crm'
        break
      case 'crm':
        return '/main/recruitstudent'
        break
      case 'finance':
        return '/main/finance'
        break
      case 'analysis':
        return '/main/statistic'
        break
      case 'sales_manage':
        return '/main/salesmanage'
        break
      case 'org_manage':
        return '/main/managesettings'
        break
      default:

        break
    }
  } else {
    return '/auth-redirect'
  }
}

function strictAdd (num1, num2) {
  return math.number(math.add(math.bignumber(num1), math.bignumber(num2)))
}
function strictSubtract (num1, num2) {
  return math.number(math.subtract(math.bignumber(num1), math.bignumber(num2)))
}
function strictMultiply (num1, num2) {
  return math.number(math.multiply(math.bignumber(num1), math.bignumber(num2)))
}
function strictDivide (num1, num2) {
  return math.number(math.divide(math.bignumber(num1), math.bignumber(num2)))
}

 /**
   * 防抖
   * @param {function} fn 执行函数
   * @param {number} wait 等待时间，毫秒
   * @param {boolean} immediate 是否立即执行
   */
function debounce (fn, wait, immediate) {
  let timeout // 局部全局变量
  return function (...args) {
    let context = this
    if (timeout) clearTimeout(timeout) // 清除计时器，但是timeout本身还在，只是不会在执行

    if (immediate) { // 总是执行第一次操作
      let callNow = !timeout // 第一次为true
      // 多次操作，timeout初始化，多次触发只有当wait等待时间结束timeout才为空
      timeout = setTimeout(function () {
        timeout = null
      }, wait)
      // 第一次为true, 执行
      if (callNow) fn.apply(context, args)
    } else { // 总是执行最后一次操作
      timeout = setTimeout(function () {
        fn.apply(context, args)
      }, wait)
    }
  }
}

function deleteLastPercentChar (str) {
  if (typeof str !== 'string' || str[str.length - 1] !== '%') {
    return str
  }
  return str.substring(0, str.length - 1)
}

/**
 * 计算转课手续费
 * 当转出课时<可转课时：最大可输入金额（ min(单价*课时数,max_amount)） - 输入金额  = 手续费
* 当转出课时=可转课时： max_amount- 输入金额 = 手续费
 * @param move_out_count 转出课时
 * @param can_move_out_count 可转出课时
 * @param max_amount 最大转出金额
 * @param move_out_price 转出金额
 * @param unit_price 单价
 */
function calculateServiceCharge (move_out_count, can_move_out_count, max_amount, move_out_price, unit_price) {
  console.log('计算手续费', move_out_count, can_move_out_count, max_amount, move_out_price, unit_price)
  if (!move_out_count || !can_move_out_count || !max_amount) {
    return 0
  }
  if (move_out_count < can_move_out_count) {
    return ((Math.min(Math.floor(unit_price * move_out_count), max_amount) - move_out_price) / 100) > 0 ? ((Math.min(Math.floor(unit_price * move_out_count), max_amount) - move_out_price) / 100).toFixed(2) : 0
  } else if (move_out_count == can_move_out_count) {
    return ((max_amount - move_out_price) / 100) > 0 ? ((max_amount - move_out_price) / 100).toFixed(2) : 0
  } else {
    return 0
  }
}

/**
 * 输入课时数时处理输入，计算金额、赠送、手续费
 * @param input_val 输入的课时数
 * @param item order_rights中的一项
 */
function calculateMoveOutCountInput (input_val, item) {
  console.log('输入课时数时处理输入', input_val, item)
  let {can_move_out_count, free_count = 0, unit_price = 0, can_move_out_amount} = item || {}

  if (free_count >= can_move_out_count) free_count = can_move_out_count // 防止情况： 赠送5 可转出6  输入1包含赠送2

  const val = Math.min(can_move_out_count, parseFloat(input_val))
  const buy_count = can_move_out_count - free_count// 可转出课时数-赠送课时数
  const input_free_count = val - buy_count // 计算赠送
  const free_out_count = Math.max(input_free_count, 0)
  // 自动计算金额(分) = int(amount x count) = int(111 x 1.11) = int(123.21) = 123 【向下取整】
  const move_out_price_amount = val >= can_move_out_count ? can_move_out_amount : Math.min(Math.floor(val * unit_price), can_move_out_amount) // 自动计算金额 输入的数量>=购买的数量 转出金额为全部
  const move_out_price = (move_out_price_amount / 100) > 0 ? (move_out_price_amount / 100).toFixed(2) : 0 // 转出金额
  const service_charge = calculateServiceCharge(val, can_move_out_count, can_move_out_amount, move_out_price_amount, unit_price)
  return {
    free_out_count,
    move_out_price,
    service_charge,
    val
  }
}

/**
 * 输入金额时处理输入，计算手续费
 * @param input_val 输入的金额
 * @param item order_rights中的一项  其中move_out_count为输入的课时数
 */
function calculateMoveOutPriceInput (input_val, item) {
  const {can_move_out_count, free_count = 0, unit_price = 0, can_move_out_amount, move_out_count = 0} = item || {}

  const new_limit = Math.min(can_move_out_amount, strictMultiply((parseFloat(input_val) || 0), 100))
  const new_limit_val = (new_limit / 100).toString()

  const service_charge = calculateServiceCharge(move_out_count, can_move_out_count, can_move_out_amount, new_limit, unit_price)

  return {
    val: new_limit_val,
    service_charge
  }
}

function handleEchartsLineYSeries (y_series, echarts) {
  if (!y_series || !echarts) {
    alert('handleEchartsLineYSeries参数错误' + typeof y_series + typeof echarts)
    return []
  }
  const colols = [
    {color: '#3A84FF', areaColor0: 'rgba(58,132,255,0)', areaColor1: 'rgba(58,132,255,0.35)'},
    {color: 'rgba(255,80,124,1)', areaColor0: 'rgba(255,80,124,0)', areaColor1: 'rgba(255,80,124,0.35)'}
  ]
  let new_y_series = null

  if (isObject(y_series)) {
    new_y_series = {
      ...y_series,
      symbol: 'circle',
      itemStyle: {
        normal: {
          color: colols[0].color,
          lineStyle: {
            color: colols[0].color,
            width: 2
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
              offset: 0,
              color: colols[0].areaColor0
            }, {
              offset: 1,
              color: colols[0].areaColor1
            }])
          }
        }
      }
    }
  } else {
    new_y_series = y_series.map((item, index) => {
      let color = ''
      let areaColor0 = ''
      let areaColor1 = ''
      if (colols[index]) {
        color = colols[index].color
        areaColor0 = colols[index].areaColor0
        areaColor1 = colols[index].areaColor1
      } else {
        color = getBrightHexColor()
        areaColor0 = color + '00'
        areaColor1 = color + '59'
      }
      // if (!colols[index]) return item;
      const new_item = {
        ...item,
        symbol: 'circle',
        itemStyle: {
          normal: {
            color: color,
            lineStyle: {
              color: color,
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: areaColor0
              }, {
                offset: 1,
                color: areaColor1
              }])
            }
          }
        }
      }
      return new_item
    })
  }

  return new_y_series
}

// 自定义字段转换为字符串展示
function referKey2Str (student_info_json, fields_item) {
  if (!isObject(student_info_json) || !isObject(fields_item)) return ''

  const val = student_info_json[fields_item.refer_key]

  if (!val) return ''

  if (typeof val === 'string' || typeof val === 'number') {
    return val
  }
  const options = fields_item.options

  if (Array.isArray(val) && Array.isArray(options) && val.length && options.length) {
    const txtArr = []
    val.forEach((item) => {
      const txt = options.find((option) => option.id == item)
      if (txt) txtArr.push(txt.value)
    })
    return txtArr.join(',')
  }

  return ''
}

function hanlerGroupClassHiddenMarkDictSort (hidden_mark_dict) {
  const obj = {}
  Object.keys(hidden_mark_dict).map(key => {
    if ((key.includes('lesson_repeat_way') && hidden_mark_dict[key] === false) || (key.includes('lesson_time') && hidden_mark_dict[key] === false)) {
      obj[key] = false
    }
  })
// 找到最大索引
  let maxIndex = 0
  for (const key in obj) {
    let parts = []
    if (key.includes('lesson_repeat_way')) {
      parts = key.split('lesson_repeat_way')
    } else if (key.includes('lesson_time')) {
      parts = key.split('lesson_time')
    }
    if (parts.length > 1) {
      maxIndex = Math.max(maxIndex, parseInt(parts[1], 10))
    }
  }

// 初始化数组
  const keys = []

// 使用 for 循环按顺序添加键
  for (let i = 1; i <= maxIndex; i++) {
    if (`lesson_repeat_way${i}` in obj) {
      keys.push(`lesson_repeat_way${i}`)
    }
    if (`lesson_time${i}` in obj) {
      keys.push(`lesson_time${i}`)
    }
  }

  return keys
}

function ttsSpeak (text) {
  const speech = new SpeechSynthesisUtterance()
  speech.lang = 'zh-CN'
  speech.text = text
  speech.pitch = 1  // 音调
  speech.rate = 0.6 // 语速
  speech.volume = 1  // 音量
  return new Promise((resolve, reject) => {
    window.speechSynthesis.speak(speech)
    speech.onend = () => {
      resolve()
    }
    speech.onerror = (e) => {
      reject(e)
    }
  })
}

function base64ToBlob (base64, mimeType) {
  const byteString = atob(base64.split(',')[1])
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uint8Array = new Uint8Array(arrayBuffer)

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i)
  }

  return new Blob([arrayBuffer], { type: mimeType })
}
function base64ToFile (base64, filename, mimeType) {
  const blob = base64ToBlob(base64, mimeType)
  return new File([blob], filename, {type: mimeType})
}

/**
 * 唤醒PC端应用工具函数
 * @param {Object} options - 配置选项
 * @param {string} options.urlScheme - 应用的URL Scheme
 * @param {string|Object} options.fallbackUrl - 备用下载链接，可以是字符串或包含win/mac属性的对象
 * @param {string} [options.fallbackUrl.win] - Windows系统下载链接
 * @param {string} [options.fallbackUrl.mac] - Mac系统下载链接
 * @param {number} [options.timeout=3000] - 超时时间(毫秒)，建议设置为3秒或以上给用户足够时间选择
 * @param {Function} [options.onSuccess] - 唤醒成功回调
 * @param {Function} [options.onFail] - 唤醒失败回调
 */
export function openApp (options) {
  const {
    urlScheme,
    fallbackUrl,
    timeout = 3000,
    onSuccess,
    onFail
  } = options

  if (!urlScheme) {
    console.error('缺少应用URL Scheme')
    return
  }

  // 尝试唤醒应用
  const iframe = document.createElement('iframe')
  iframe.style.cssText = 'display:none;width:0;height:0;'
  document.body.appendChild(iframe)

  // 通过iframe尝试打开应用
  iframe.src = urlScheme

  // 立即调用成功回调（表示已尝试唤醒）
  onSuccess && onSuccess()

  // 使用blur事件检测页面是否失去焦点（应用可能已打开）
  let isFocus = true
  let downloadTriggered = false

  // 页面失去焦点事件监听器
  const onBlur = () => {
    isFocus = false
    // 用户选择了打开应用，清除定时器防止触发下载
    clearTimeout(timer)
    window.removeEventListener('blur', onBlur)
  }

  // 添加blur事件监听
  window.addEventListener('blur', onBlur)

  // 移除iframe
  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 100)

  // 超时后触发下载（用户未打开应用或应用未安装）
  const timer = setTimeout(() => {
    window.removeEventListener('blur', onBlur)

    // 只有在页面仍有焦点时才触发下载（用户未打开应用）
    if (isFocus && !downloadTriggered) {
      downloadTriggered = true

      if (fallbackUrl) {
        onFail && onFail()

        // 获取适合当前系统的下载链接
        let downloadUrl = ''
        if (typeof fallbackUrl === 'string') {
          downloadUrl = fallbackUrl
        } else if (typeof fallbackUrl === 'object') {
          // 使用项目中已有的平台检测函数
          const platform = pc_option_system()
          if (platform === 1 && fallbackUrl.win) {
            // Windows系统
            downloadUrl = fallbackUrl.win
          } else if (platform === 2 && fallbackUrl.mac) {
            // Mac系统
            downloadUrl = fallbackUrl.mac
          } else {
            // 默认情况使用win链接或第一个可用链接
            downloadUrl = fallbackUrl.win || fallbackUrl.mac || ''
          }
        }

        // 如果有下载链接，则触发下载
        if (downloadUrl) {
          // 创建隐藏的iframe触发下载，不跳转页面
          const downloadIframe = document.createElement('iframe')
          downloadIframe.style.cssText = 'display:none;width:0;height:0;'
          downloadIframe.src = downloadUrl
          document.body.appendChild(downloadIframe)

          // 一段时间后移除iframe
          setTimeout(() => {
            document.body.removeChild(downloadIframe)
          }, 1000)
        }
      } else {
        onFail && onFail()
      }
    }
  }, timeout)
}

export default {
  lazyLoadView,
  getAuth,
  getOrgId,
  getUniqueMD5,
  isObject,
  deepClone,
  filterTextMaxLen,
  parseTime,
  formatCardDateStr,
  getMD5ByURL,
  closePopover,
  dateFormate,
  judgePlatForm,
  handlerMomeny,
  handlerMemorySpace,
  triggerDownloadAPI,
  jumpUrlByA,
  downloadExcelByA,
  downloadPicURLByA,
  triggerDownloadFileByEnd,
  smallImageURL,
  uploadFile,
  uploadRichTextEditorFile,
  uploadBatchFile,
  getFileMD5,
  findTimeZoneName,
  curryingFunction,
  setDefaultErr,
  normalizeExpireMonthDay,
  getSpecExpireText,
  getSpecValueStr,
  formValidateMessage,
  formValidate,
  desensitizationMobile,
  closePageTab,
  limitIntegetInput,
  limitAmount2PointAfterInput,
  limitAmount1PointAfterInput,
  transferAmount2yuan,
  // showPageLoading,
  getAddOrSubDayDate,
  getArrayFromToByStep,
  getExistKeyParams,
  transferColorFormHex,
  lightenDarkenColor,
  getAuthorizationWithOrgId,
  refreshOldData,
  toFixNumber,
  judgeWhetherItFromManban,
  judgeToPage,
  judgeToPageForDredirect,
  strictAdd,
  strictSubtract,
  strictMultiply,
  strictDivide,
  debounce,
  deleteLastPercentChar,
  wechatBrowserWarn,
  calculateServiceCharge,
  calculateMoveOutCountInput,
  calculateMoveOutPriceInput,
  handleEchartsLineYSeries,
  referKey2Str,
  hanlerGroupClassHiddenMarkDictSort,
  ttsSpeak,
  base64ToFile
  // getAuthorization
}
